// src/components/admin/notification/NotificationLogic.js
import { getToken, onMessage } from "firebase/messaging";
import { doc, setDoc } from "firebase/firestore"; 
import { messaging, db } from "../../../firebaseConfig"; 

// 1. VAPID Key from Firebase Console > Cloud Messaging > Web Configuration
const VAPID_KEY = "BEVt_quf_J_kNYD2l0msp1U1kC5DGdzEsqehwCsmq5e2Zuvi7cfDcQXTEdaF9BrolGEfeNXaCZxa_5FY1OWAITk"; 

/**
 * Requests permission and saves the token to the user's Firestore profile.
 * Call this when the Tutor logs in or clicks a "Enable Notifications" button.
 */
export const requestNotificationPermission = async (uid) => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      // Get the token
      const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });
      
      if (currentToken) {
        // Save token to Firestore
        await saveTokenToDatabase(uid, currentToken);
        console.log("Notification token saved.");
        return true;
      } else {
        console.warn("No registration token available. Request permission to generate one.");
        return false;
      }
    } else {
      console.warn("Notification permission denied.");
      return false;
    }
  } catch (error) {
    console.error("An error occurred while retrieving token.", error);
    return false;
  }
};

/**
 * Save the token to a subcollection or field. 
 * Using a subcollection handles multiple devices (Phone, Laptop) better than a single field.
 */
const saveTokenToDatabase = async (uid, token) => {
  // We use a subcollection 'fcm_tokens' to store multiple devices per user
  const tokenRef = doc(db, "users", uid, "fcm_tokens", token);
  
  await setDoc(tokenRef, {
    token: token,
    lastSeen: new Date(),
    deviceType: /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop"
  });
};

/**
 * Listener for foreground messages (when the app is open)
 */
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });